import { Injectable } from '@angular/core';
import { units } from '../data/portal-products';
import { HttpService } from './http.service';
import { DashboardResponse } from '../portal/dsc-dashboard/dsc-dashboard.component';

@Injectable()
export class PortalProductsHttp {
  constructor(protected httpService: HttpService) {}

  saveSignupForm = async (data: { productId: any; values: any; attachments: any[] }, userId) =>
    this.httpService.post(`/products/auto-save${(userId && '?userId=' + userId) || ''}`, data);

  getSignupForm = async (productId, userId) => this.httpService.get(`/products/${productId}${(userId && '?userId=' + userId) || ''}`);

  submitSignupForm = async (productId) => this.httpService.post(`/products/signup?productId=${productId}`);

  cancelSignupForm = async (productId) => this.httpService.post(`/products/${productId}/reset`);

  getProductStatuses = async () => this.httpService.get('/users/products');

  userChangeApprovalPendingToModifying = async (id) => this.httpService.put(`/users/products/${id}/modify`, id);
  getUtTransactionIndividual = async (type) => this.httpService.get(`/ut-request/master-data?requestType=${type}`);
  getUtTransaction = async (type, accountType, partyId) =>
    this.httpService.get(`/ut-request/ut-master-data?requestType=${type}&accountType=${accountType}&crmCode=${partyId}`);
  checkServerTime = async (time) => this.httpService.get(`/ut-request/is-future-time?hour=${time}`);
  postUtTransactions = async (type, accountType, partyId, data) =>
    this.httpService.post(`/ut-request?requestType=${type}&accountType=${accountType}&crmCode=${partyId}`, data);
  getUtTransactionHistory = async (type, count, latest, accountType, partyId, date, profileId) =>
    this.httpService.get(
      `/ut-request?requestType=${type}&recordCount=${count}${(latest && '&latest=' + latest) || ''}${(date && '&fromDate=' + date) || ''}${
        (profileId && '&customerId=' + profileId) || ''
      }${(accountType && '&accountType=' + accountType) || ''}${(partyId && '&crmCode=' + partyId) || ''}`
    );
  getUtTransactionHistoryMinDate = async (crmId) =>
    this.httpService.get(`/ut-request/pending-transactions-min-date${(crmId && '?crmId=' + crmId) || ''}`);
  getRedemptionLimit = async (fundId, subAcc) =>
    this.httpService.get(`/ut-request/get-redemption-limit?fundCode=${fundId}&subAccount=${subAcc}`);
  checkWMSStatus = async () => this.httpService.get(`/account/check-wms-rest-api-availability`);
  sendOTP = async () =>
    this.httpService.get(`/users/send-otp
  `);
  validateOtp = async (otp) =>
    this.httpService.get(`/users/validate-otp?otp=${otp}
`);
  getClientReqMasterData = (type, accountType, partyId) =>
    this.httpService.get(`/client-request/master-data?requestType=${type}&accountType=${accountType}&crmCode=${partyId}`);

  getVkycAgentAvailabiliy = async () => this.httpService.get(`/vkyc-scheduling/agent-availability`);
  getVkycSchedulingTimeSlots = async (productSignUpId) =>
    this.httpService.get(`/vkyc-scheduling/time-slots?productSignUpId=${productSignUpId}`);
  saveBusyTime = async (id, date) => this.httpService.post(`/vkyc-scheduling/save-agent-busy-time?timeslotId=${id}&date=${date}`);
  removeAgentBusyTime = async (id) => this.httpService.delete(`/vkyc-scheduling/remove-agent-busy-time?id=${id}`);

  getVkycClientDetails = async (prdId, userId) => this.httpService.get(`/products/${prdId}/vkyc-details?userId=${userId}`);
  createFundTransaction = async (accType, crmCode, data) =>
    this.httpService.post(`/ut-request?requestType=TRANSFER&accountType=${accType}&crmCode=${crmCode}`, data);

  getBDProductBalances = async (customerId) =>
    this.httpService.get(`/account/me/financial/balance-summary${(customerId && '?customerId=' + customerId) || ''}`);
  getEquityPortfolio = async (customerId, page, size, sort) =>
    this.httpService.get(
      `/account/me/financial/equity-portfolio?page=${page}&size=${size}${(sort && '&sort=' + sort) || ''}${
        (customerId && '&investorCode=' + customerId) || ''
      } `
    );
  getEquityPortfolioCount = async (customerId) =>
    this.httpService.get(`/account/me/financial/equity-portfolio/count${(customerId && '?investorCode=' + customerId) || ''}`);
  getBalances = async () => this.httpService.get(`/account/me/financial/balance-summary-bangladesh`);

  getLedgerSummary = async (fromDate, toDate, investorCode) =>
    this.httpService.get(`/margin-trade/ledger-summary?fromDate=${fromDate}&toDate=${toDate}&investorCode=${investorCode}`);
  getVerificationCodes = async (searchText, page, size) =>
    this.httpService.get(`/data-adjustments/verification-codes?searchText=${searchText || ''}&page=${page}&size=${size}`);
  deleteVerificationCode = async (codeId) => this.httpService.delete(`/data-adjustments/delete-verification-code/${codeId}`);
  getPrdSignupProgress = async (productType) => this.httpService.get(`/products/get-product-signup-progress?productType=${productType}`);
  getDscDashboardData = () => this.httpService.get(`/dsc-data/dashboard`);
}

@Injectable()
export class PortalProductsService {
  private _products;
  private productStatusList;
  private getProductStatusesPromise: Promise<any[]>;

  get getProductStatus() {
    return this._products;
  }
  setProductStatus(products) {
    this._products = products;
  }
  constructor(protected http: PortalProductsHttp) {}

  async saveSignupForm(data, userId?) {
    return await this.http.saveSignupForm(data, userId);
  }

  async getSignupForm(productId, userId?) {
    return await this.http.getSignupForm(productId, userId);
  }

  async getProductsByUser() {
    return await this.http.getProductStatuses();
  }
  async getProductStatuses() {
    this._products = await this.http.getProductStatuses();
    return this._products;
  }

  async syncProducts() {
    if (this._products) {
      return this._products;
    } else {
      await this.getProductStatuses();
      return this._products;
    }
  }

  async mergeProductStatus() {
    let productStatusList = await this.getProductStatuses();
    units.forEach((unit) => {
      unit.products.forEach((product) => {
        let productStatus = productStatusList.find((i) => i.productId === product.id);
        if (productStatus) {
          product.status = productStatus.status;
          product.statusPending = ['Approval Pending', 'Rejected', 'Submitted'].includes(productStatus.status);
        } else {
          product.status = undefined;
          product.statusPending = undefined;
        }
      });
    });
  }

  submitSignupForm = async (productId) => this.http.submitSignupForm(productId);

  cancelSignupForm = async (productId) => this.http.cancelSignupForm(productId);
  userChangeApprovalPendingToModifying = async (id) => this.http.userChangeApprovalPendingToModifying(id);
  getUtTransactionIndividual = async (transaction) => this.http.getUtTransactionIndividual(transaction);
  getUtTransaction = async (transaction, accountType?, partyId?) => this.http.getUtTransaction(transaction, accountType, partyId);
  checkServerTime = async (time) => this.http.checkServerTime(time);
  postUtTransactions = async (type, accountType, partyId, data) => this.http.postUtTransactions(type, accountType, partyId, data);
  getUtTransactionHistory = async (type, count, latest, accountType, partyId, date?, profileId?) =>
    this.http.getUtTransactionHistory(type, count, latest, accountType, partyId, date, profileId);
  getUtTransactionHistoryMinDate = async (crmId?) => this.http.getUtTransactionHistoryMinDate(crmId);
  getRedemptionLimit = async (fundId, subAcc) => this.http.getRedemptionLimit(fundId, subAcc);
  checkWMSStatus = async () => this.http.checkWMSStatus();
  sendOTP = async () => this.http.sendOTP();
  validateOtp = async (otp) => this.http.validateOtp(otp);
  getClientReqMasterData = async (transaction, accountType?, partyId?) =>
    this.http.getClientReqMasterData(transaction, accountType, partyId);
  getVkycAgentAvailabiliy = async () => this.http.getVkycAgentAvailabiliy();
  getVkycSchedulingTimeSlots = async (productSignUpId) => this.http.getVkycSchedulingTimeSlots(productSignUpId);
  saveBusyTime = async (id, date) => this.http.saveBusyTime(id, date);
  removeAgentBusyTime = async (id) => this.http.removeAgentBusyTime(id);

  getVkycClientDetails = async (prdId, userId?) => this.http.getVkycClientDetails(prdId, userId);
  createFundTransaction = async (accType, crmCode, data) => this.http.createFundTransaction(accType, crmCode, data);
  getBDProductBalances = async (customerId) => this.http.getBDProductBalances(customerId);
  getEquityPortfolio = async (customerId, page, size, sort) => this.http.getEquityPortfolio(customerId, page, size, sort);
  getEquityPortfolioCount = async (customerId?) => this.http.getEquityPortfolioCount(customerId);
  getBalances = async () => this.http.getBalances();
  getLedgerSummary = async (fromDate, toDate, investorCode) => this.http.getLedgerSummary(fromDate, toDate, investorCode);
  getVerificationCodes = async (searchText, page, size) => this.http.getVerificationCodes(searchText, page, size);
  deleteVerificationCode = async (codeId) => this.http.deleteVerificationCode(codeId);
  getPrdSignupProgress = async (prdType) => this.http.getPrdSignupProgress(prdType);
  getDscDashboardData = async (): Promise<DashboardResponse> => this.http.getDscDashboardData();
}
